import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {GroupConfig} from '../../../shared/models/config';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../../reducers';
import {Observable, Subscription} from 'rxjs';
import {Player} from '../../../shared/models/player';
import {SelectedPlayers} from '../../models/player-filter';
import { SetDefaultPlayerAction } from '../../actions/default-player';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-default-player',
  templateUrl: './default-player.component.html',
  styleUrls: ['./default-player.component.scss']
})
export class DefaultPlayerComponent implements OnInit , OnDestroy {
  form: FormGroup;
  formConfig: GroupConfig;
  players$: Observable<Player[]>;
  selectedPlayers$: Observable<SelectedPlayers[]>;
  selectedPlayer: SelectedPlayers;
  players: Player[];
  private sub$: Subscription;
  @ViewChild('elementGroup' , {static: false}) el: ElementRef;

  constructor(private bsModalRef: BsModalRef,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private storeSite: Store<fromSites.AppState>) {
  }

  ngOnInit(): void {
    this.selectedPlayers$ = this.storeSite.pipe(select(fromSites.selectors.getPlayersSelected));
    this.sub$ = this.selectedPlayers$.subscribe(( selectedPlayer => {
      if (selectedPlayer && selectedPlayer[0]) {
        this.selectedPlayer = selectedPlayer[0];
      }
    })
    );
  }

  send(): void {
    this.storeSite.dispatch(new SetDefaultPlayerAction(this.selectedPlayer.deviceID));
    this.close();
  }

  close(): void {
    this.bsModalRef.hide()
  }

  ngOnDestroy(): void {
    if (this.sub$) {
      this.sub$.unsubscribe();
    }
  }

}
